module.exports = __webpack_public_path__ + "img/arrow-up.32a4aabe.svg";